import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../../CurrentCollectionStep/BuilderV2/Types';
import PopoverContent from '../PopoverContent';

export interface Props {
  experienceResource: Maybe<ExperienceResource>;
}

function ExperienceCard({ experienceResource }: Props) {
  return experienceResource
    .map((experienceResource) => <PopoverContent experienceResource={experienceResource} />)
    .getOrElse(emptyFragment);
}

export default observer(ExperienceCard);
